import { defineMessages } from 'react-intl'

export default defineMessages({
  accountDeleteDescription: {
    id: 'accountSettings.deleteAccount.description',
    defaultMessage:
      'Deleting your account is a big decision — we’ll send a Starbucks Card for any remaining funds in your account, but your Stars and account history will not be recoverable.',
  },
  phoneDescription: {
    id: 'accountSettings.settingsMfa.phoneDescription',
    defaultMessage:
      'This phone number will be used to confirm your identity when needed. You can update this number and we’ll send you a new verification code. Message and data rates may apply.',
  },
  noMoreRetries: {
    id: 'accountSettings.settingsMfa.noMoreRetries.error',
    defaultMessage: 'No more tries left. Try again later.',
  },
  phoneNumberInvalid: {
    id: 'accountSettings.security.addPhoneNumber.invalid',
    defaultMessage: 'Please enter 10-digit phone number',
  },
  termsAndConditionsLinkText: {
    id: 'accountSettings.settingsMfa.termsAndConditionsLinkText',
    defaultMessage: 'Terms & Conditions',
  },
  needHelpLinkText: {
    id: 'accountSettings.settingsMfa.needHelpLinkText',
    defaultMessage: 'Need Help?',
  },
  unenrollDialog: {
    id: 'accountSettings.settingsMfa.unenrollDialog',
    defaultMessage:
      'This will leave your account less protected. Are you sure?',
  },
  unenrollSuccessful: {
    id: 'accountSettings.settingsMfa.unenrollSuccessful',
    defaultMessage: 'Phone number unenrolled',
  },
})
